import React, { useEffect } from 'react'
import {
  Button,
  TextHeading,
  Space,
  TextBody,
  Box,
  ButtonGroup,
} from '@ally/metronome-ui'
import allytm from '@ally/allytm'
import { AddBeneficiary } from './AddBeneficiaryModal'

const headerRef = React.createRef<HTMLHeadingElement>()

export const OtherFdicModalContent: React.FC<{
  setDisplayOtherFdicModalContent: React.Dispatch<React.SetStateAction<boolean>>
  setAddBeneficiary: React.Dispatch<React.SetStateAction<AddBeneficiary>>
  setClassificationToOther: React.Dispatch<React.SetStateAction<boolean>>
}> = ({
  setDisplayOtherFdicModalContent,
  setAddBeneficiary,
  setClassificationToOther,
}) => {
  const handleClick = async (): Promise<void> => {
    allytm.event('clickEvent', {
      tagName: 'BUTTON',
      allytmln: 'cta-continueFDIC',
      href: 'https://www.fdic.gov/',
    })
    await setClassificationToOther(true)
    await setDisplayOtherFdicModalContent(false)
    window.open('https://www.fdic.gov/', '_blank')
    await setAddBeneficiary({ addType: 'add-new' })
  }

  const handleCancel = async (): Promise<void> => {
    await setClassificationToOther(true)
    await setDisplayOtherFdicModalContent(false)
    await setAddBeneficiary({ addType: 'add-new' })
  }

  useEffect(() => {
    // istanbul ignore next - Low value test
    headerRef.current?.focus()
  }, [])

  return (
    <Space mb="md">
      <TextHeading
        tag="h1"
        size="sm"
        weight="bold"
        ref={headerRef}
        tabIndex={-1}
        id="other-fdic-heading"
      >
        Important Notice
      </TextHeading>
      <TextBody tag="p" size="md" weight="bold">
        You&apos;re leaving ally.com
      </TextBody>
      <TextBody tag="p" size="md">
        Selecting{' '}
        <TextBody tag="span" size="md" weight="bold">
          Continue
        </TextBody>{' '}
        will take you to a website that Ally does not own or control. We are not
        responsible for the products, services or information you may find or
        provide there. Also, you should read and understand how that site&apos;s
        privacy policy level of security and terms and conditions may impact
        you.
      </TextBody>
      <Box marginY="md">
        <ButtonGroup>
          <Button text="Continue" onClick={handleClick} />
          <Button
            allytmln="cancel - close FDIC modal"
            text="Cancel"
            onClick={handleCancel}
            variant="link"
          />
        </ButtonGroup>
      </Box>
    </Space>
  )
}
